// extracted by mini-css-extract-plugin
export default {"addToCartControl":"v2-z","giftCard":"w2-z","btnContainer":"x2-z","cartButton":"y2-z","disabled":"z2-z"};